//@ts-ignore
import lightGallery from 'lightgallery/lib/index.js';
import 'lightgallery/css/lightgallery-bundle.min.css';
import { handleResult, solvePluginName } from './util';
;
export default async function initLightGallery() {
    const { plugins, ...opts } = _iro.lightGallery;
    lightGallery(document.querySelector('.entry-content'), {
        plugins: plugins && (await Promise.allSettled(plugins.map(
        //moduleNameFormat: lgHash->lg-hash
        name => import(
        /* webpackChunkName: "lg-" */
        'lightgallery/plugins/' + solvePluginName(name) + '.min.js'))))
            .map(handleResult),
        ...opts
    });
}
